import React from 'react'

import { joinClassNames } from '../../utils'
import { Carousel } from '../Carousel'
import { usePageData } from '../../hooks'

import "../../../node_modules/slick-carousel/slick/slick.css"
import './Homepage.scss'


const Homepage = ({ endpoint, linkText, pageTitle }) => {

  const { loading, pageData } = usePageData()

  document.title=pageTitle

  const Caption = ({ className, data: { title } = {} }) => (
    <span className={ joinClassNames('home--caption', className) }>
      { title }
    </span>
  )

  return (
    <Carousel
      className="home"
      onSlideChange={ (val) => console.log(val) }
      overlay={ Caption }
      loading={ loading }
      slides={pageData && pageData[0].slides}
    />
  )
}

export default Homepage

